import React, { useState } from 'react';

const EyeIcon = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

const EyeOffIcon = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-5 0-9.27-3.11-11-8 1.02-2.89 2.98-5.2 5.47-6.61" />
        <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c5 0 9.27 3.11 11 8a11.7 11.7 0 0 1-2.16 3.19" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);

const PasswordField = ({
    name,
    value,
    onChange,
    className = '',
    autoComplete = 'current-password',
    required,
    'aria-label': ariaLabel = 'Password',
    ...rest
}) => {
    const [visible, setVisible] = useState(false);
    const label = visible ? `Hide ${ariaLabel.toLowerCase()}` : `Show ${ariaLabel.toLowerCase()}`;

    return (
        <div className="msv-password-field">
            <input
                type={visible ? 'text' : 'password'}
                name={name}
                value={value}
                onChange={onChange}
                className={className}
                autoComplete={autoComplete}
                required={required}
                {...rest}
            />
            <button
                type="button"
                className="msv-password-toggle"
                onClick={() => setVisible((v) => !v)}
                aria-label={label}
                aria-pressed={visible}
            >
                {visible ? <EyeOffIcon /> : <EyeIcon />}
            </button>
        </div>
    );
};

export default PasswordField;
